// src/hr/kit/Btn.js -- buttons (and button-styled links).
// variant: 'main' (accent gradient) | 'ghost' | 'danger' | 'approve'; size: 'md' | 'sm'.
// loading disables the button, marks it busy and swaps the icon for a spinner.
import React, { forwardRef } from 'react';
import { cx, renderIcon } from './util';

const VARIANTS = ['main', 'ghost', 'danger', 'approve'];

export const Btn = forwardRef(function Btn({
  variant = 'main', size = 'md', loading = false, icon, iconAfter, href, target, rel,
  type = 'button', disabled = false, className, children, ...rest
}, ref) {
  const cls = cx(
    'hrp-btn',
    `hrp-btn--${VARIANTS.includes(variant) ? variant : 'main'}`,
    `hrp-btn--${size === 'sm' ? 'sm' : 'md'}`,
    loading && 'hrp-btn--loading',
    children == null && 'hrp-btn--icon',
    className
  );
  const content = (
    <>
      {loading
        ? <span className="hrp-spin" aria-hidden="true" />
        : icon && <span className="hrp-btn__ic" aria-hidden="true">{renderIcon(icon)}</span>}
      {children != null && <span className="hrp-btn__label">{children}</span>}
      {iconAfter && !loading && <span className="hrp-btn__ic" aria-hidden="true">{renderIcon(iconAfter)}</span>}
    </>
  );

  if (href) {
    const safeRel = rel || (target === '_blank' ? 'noopener noreferrer' : undefined);
    return (
      <a ref={ref} href={href} target={target} rel={safeRel} className={cls} aria-disabled={disabled || undefined} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <button
      ref={ref}
      type={type}
      className={cls}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {content}
    </button>
  );
});

export default Btn;
